import { render, staticRenderFns } from "./SkillsWeightageThresholdsView.vue?vue&type=template&id=b0422492&"
import script from "./SkillsWeightageThresholdsView.vue?vue&type=script&lang=js&"
export * from "./SkillsWeightageThresholdsView.vue?vue&type=script&lang=js&"
import style0 from "./SkillsWeightageThresholdsView.vue?vue&type=style&index=0&id=b0422492&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports